import type { Locale as DateFnsLocale } from "date-fns";
import { enUS, fr } from "date-fns/locale";

/**
 * Maps app i18n language (e.g. from i18next) to a date-fns locale for calendars and parsing.
 * Extend when adding UI translations for more locales.
 */
export function getDateFnsLocale(language?: string): DateFnsLocale {
  const base = language?.split("-")[0]?.toLowerCase() ?? "en";
  if (base === "fr") return fr;
  return enUS;
}
